import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, HashRouter } from "react-router-dom";
import App from "./components/App/App";
import "./assets/stylesheets/index.css";
import registerServiceWorker from "./registerServiceWorker";
import { isCordovaApp } from "./utils/cordovaUtils";
import { hotjar } from "react-hotjar";

let Router;

const startApp = () =>
  ReactDOM.render(
    <div>
      <Router>
        <App />
      </Router>
    </div>,
    document.getElementById("root")
  );

if (process.env.REACT_APP_HOTJAR_ID) {
  const hotjarSnippetVersion = 6;
  hotjar.initialize(process.env.REACT_APP_HOTJAR_ID, hotjarSnippetVersion);
}

if (!isCordovaApp) {
  Router = BrowserRouter;
  startApp();
  registerServiceWorker();
} else {
  Router = HashRouter;
  document.addEventListener("deviceready", startApp, false);
}
